import { ArrowCircleUpSharp } from "@mui/icons-material";
import { Box, Checkbox, Stack, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { useRef } from "react";
import SubmitModal from "../elements/Admin/SubmitModal";
import Header from "../elements/Header";
import Sidebar from "../elements/Sidebar";
import formService from "../services/formService";
import { blueGradientBackground, pink } from "../shared/colours";
import { borderStyle, cardStyle, contentBoxStyle } from "../shared/Theme";

const CyberInsurance = () => {
	
	let [ showSubmitModal, setShowSubmitModal ] = useState(false);
	let [ sentSuccess, setSentSuccess ] = useState(false);

	const companyName = useRef(null);
	const grossRevenue = useRef(null);
	const dataRecords = useRef(null);
	const paymentProcessingYes = useRef(null);
	const paymentProcessingNo = useRef(null);
	const annualTransactions = useRef(null);
	const internationalBusinessYes = useRef(null);
	const internationalBusinessNo = useRef(null);
	
	const handleSubmitClick = async () => {
		setSentSuccess(false);
		setShowSubmitModal(true);
		await formService.insurance({
			companyName: companyName.current.value,
			grossRevenue: grossRevenue.current.value,
			dataRecords: dataRecords.current.value,
			paymentProcessingYes: paymentProcessingYes.current.checked,
			paymentProcessingNo: paymentProcessingNo.current.checked,
			annualTransactions: annualTransactions.current.value,
			internationalBusinessYes: internationalBusinessYes.current.checked,
			internationalBusinessNo: internationalBusinessNo.current.checked,
		});
		setSentSuccess(true);
		setTimeout(() => {
			setShowSubmitModal(false);
		}, 1500);
	};
	
	const handleSubmitModalClose = () => {
		setSentSuccess(false);
		setShowSubmitModal(false);
	};
	
	return (
		<Box sx={{ display: "flex" }}>
			<Sidebar/>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Header pageTitle="Cyber Insurance"/>
				<Box sx={contentBoxStyle}>
					<Stack sx={{ ...cardStyle, width: "80%", margin: "auto", paddingBottom: "1em", padding: "1em" }} justifyContent="center">
						<Typography
							variant="h5"
							sx={{ width: "100%", textAlign: "center", fontWeight: "bold", marginTop: "1em" }}
						>
							Cyber Insurance Quotation
						</Typography>
						<Typography
							sx={{
								width: "100%",
								textAlign: "center",
								margin: "2em 0 3em 0",
								fontSize: "0.8em",
								borderLeft: "2px solid",
								borderRight: "2px solid",
								...borderStyle
							}}
						>
							<span style={{ fontWeight: "bold" }}>Cymplify Ltd </span>works closely with a carefully
							selected group of specialist Cyber Insurance MGA's and Insurance Brokers who recognise
							the importance of the<br/>
							<span style={{ fontWeight: "bold" }}>Cymplify Active Cyber Risk Management platform </span>
							in dramatically reducing our clients exposure to Cyber Risk.<br/><br/>
							Cyber Insurance is a key element of any Organisations modern Cyber Risk Management Strategy,
							and through our Partnerships we are able to provide initial Cyber<br/>
							Insurance Quotations that reflect your commitment to Active Risk Monitoring.<br/><br/>
							<span style={{ fontWeight: "bold", color: pink }}>PLEASE NOTE</span>
							<span style={{ fontWeight: "bold" }}> - Cymplify Ltd </span>is able to provide a facility
							for initial<span style={{ fontWeight: "bold" }}> Cyber Insurance Quotations </span>
							<span style={{ fontWeight: "bold", textDecoration: "underline" }}> only</span>. 
							Cymplify Ltd is <span style={{ fontWeight: "bold" }}> not </span>an Insurance Provider and
							the actual Quote {`&`}<br/>
							Bind process, the Policy itself, along with agreed coverage, excess etc. is made directly
							with the Insurer you choose - not with
							<span style={{ fontWeight: "bold" }}> Cymplify Ltd</span>. All policy documents will<br/>
							be sent to you by the insurer and any issues, changes or claims are to be made directly
							with the insurer<br/><br/>
							In order to provide an initial Quotation, the following questions must be answered as
							accurately as possible:
						</Typography>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="center"
							sx={{ width: "100%", marginBottom: "1em" }}
						>
							<Typography sx={{ width: "35%", fontSize: "0.8em" }}>
								<span style={{ fontWeight: "bold", fontSize: "1.2em" }}>Registered Company Name</span>
								<br/>
								As it appears on Companies House Records if registered in the<br/>
								UK
							</Typography>
							<TextField
								inputRef={companyName}
								size="small"
								sx={{
									border: `2px solid ${pink}`,
									borderRadius: "0.5em",
									width: "35%",
									'& .MuiOutlinedInput-root.Mui-focused': {
										"& > fieldset": {
											border: "0"
										}
									},
									'&:hover fieldset': {
										border: "0"
									}
								}}
							/>
						</Stack>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="center"
							sx={{ width: "100%", marginBottom: "1em" }}
						>
							<Typography sx={{ width: "35%", fontSize: "0.8em" }}>
								<span style={{ fontWeight: "bold", fontSize: "1.2em" }}>Gross Revenue</span>
								<br/>
								Enter the last posted or expected annual turnover of the insured<br/>
								party
							</Typography>
							<TextField
								inputRef={grossRevenue}
								size="small"
								sx={{
									border: `2px solid ${pink}`,
									borderRadius: "0.5em",
									width: "35%",
									'& .MuiOutlinedInput-root.Mui-focused': {
										"& > fieldset": {
											border: "0"
										}
									},
									'&:hover fieldset': {
										border: "0"
									}
								}}
							/>
						</Stack>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="center"
							sx={{ width: "100%", marginBottom: "1em" }}
						>
							<Typography sx={{ width: "35%", fontSize: "0.8em" }}>
								<span style={{ fontWeight: "bold", fontSize: "1.2em" }}>Data Records</span>
								<br/>
								Enter the total number of individuals you hold any type of data<br/>
								on
							</Typography>
							<TextField
								inputRef={dataRecords}
								size="small"
								sx={{
									border: `2px solid ${pink}`,
									borderRadius: "0.5em",
									width: "35%",
									'& .MuiOutlinedInput-root.Mui-focused': {
										"& > fieldset": {
											border: "0"
										}
									},
									'&:hover fieldset': {
										border: "0"
									}
								}}
							/>
						</Stack>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="center"
							sx={{ width: "100%", marginBottom: "1em" }}
						>
							<Typography sx={{ width: "35%", fontSize: "0.8em" }}>
								<span style={{ fontWeight: "bold", fontSize: "1.2em" }}>Payment Processing</span>
								<br/>
								Does the insured party process any kind of payments - through<br/>
								a payment card chip {`&`} pin machine or Online?
							</Typography>
							<Stack
								direction="row"
								alignItems="center"
								justifyContent="center"
								spacing={6}
								sx={{ width: "35%" }}
							>
								<Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
									<Typography sx={{ fontWeight: "bold" }}>
										Yes
									</Typography>
									<Checkbox
										inputRef={paymentProcessingYes}
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "2.5em",
											height: "2.5em",
											'&.Mui-checked': {
												color: pink
											}
										}}
										icon={<React.Fragment/>}
									/>
								</Stack>
								<Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
									<Typography sx={{ fontWeight: "bold" }}>
										No
									</Typography>
									<Checkbox
										inputRef={paymentProcessingNo}
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "2.5em",
											height: "2.5em",
											'&.Mui-checked': {
												color: pink
											}
										}}
										icon={<React.Fragment/>}
									/>
								</Stack>
							</Stack>
						</Stack>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="center"
							sx={{ width: "100%", marginBottom: "1em" }}
						>
							<Typography sx={{ width: "35%", fontSize: "0.8em" }}>
								<span style={{ fontWeight: "bold", fontSize: "1.2em" }}>Annual Transactions</span>
								<br/>
								Enter the total number of online payment or card terminal<br/>
								transactions per year
							</Typography>
							<TextField
								inputRef={annualTransactions}
								size="small"
								sx={{
									border: `2px solid ${pink}`,
									borderRadius: "0.5em",
									width: "35%",
									'& .MuiOutlinedInput-root.Mui-focused': {
										"& > fieldset": {
											border: "0"
										}
									},
									'&:hover fieldset': {
										border: "0"
									}
								}}
							/>
						</Stack>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="center"
							sx={{ width: "100%", marginBottom: "1em" }}
						>
							<Typography sx={{ width: "35%", fontSize: "0.8em" }}>
								<span style={{ fontWeight: "bold", fontSize: "1.2em" }}>International Business</span>
								<br/>
								Does the insured party have any clients or do any business in the<br/>
								USA and/or Canada?
							</Typography>
							<Stack
								direction="row"
								alignItems="center"
								justifyContent="center"
								spacing={6}
								sx={{ width: "35%" }}
							>
								<Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
									<Typography sx={{ fontWeight: "bold" }}>
										Yes
									</Typography>
									<Checkbox
										inputRef={internationalBusinessYes}
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "2.5em",
											height: "2.5em",
											'&.Mui-checked': {
												color: pink
											}
										}}
										icon={<React.Fragment/>}
									/>
								</Stack>
								<Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
									<Typography sx={{ fontWeight: "bold" }}>
										No
									</Typography>
									<Checkbox
										inputRef={internationalBusinessNo}
										sx={{
											border: `2px solid ${pink}`,
											borderRadius: "0.5em",
											width: "2.5em",
											height: "2.5em",
											'&.Mui-checked': {
												color: pink
											}
										}}
										icon={<React.Fragment/>}
									/>
								</Stack>
							</Stack>
						</Stack>
						<Stack direction="row" justifyContent="flex-end">
							<Stack
								direction="row"
								sx={{
									width: "15em",
									height: "4em",
									marginTop: "2em",
									borderRadius: "2.5em",
									background: blueGradientBackground,
									"&:hover": {
										cursor: "pointer"
									}
								}}
								alignItems="center"
								justifyContent="center"
								spacing={1}
								onClick={handleSubmitClick}
							>
								<Typography
									sx={{ fontWeight: "bold", color: "#ffffff", paddingLeft: "0.5em" }}
								>
									Request Quotation
								</Typography>
								<ArrowCircleUpSharp
									sx={{
										width: "2.5em",
										height: "2.5em",
										transform: "rotate(90deg)",
										color: "#ffffff"
									}}
								/>
							</Stack>
						</Stack>
					</Stack>
					<SubmitModal
						open={showSubmitModal}
						sentSuccess={sentSuccess}
						onClose={handleSubmitModalClose}
					/>
				</Box>
			</Box>
		</Box>
	);

}

export default CyberInsurance;